module.exports = __webpack_public_path__ + "img/logo.e146f971.png";